<template>
  <div class="gy-register">
    <h2 class="gy-register-title" style="padding-left: 30px">欢迎注册</h2>
    <div class="gy-register-steps" style="max-width: 550px">
      <gy-steps :current="current">
        <gy-step title="填写邀请码"></gy-step>
        <gy-step title="填写入驻信息"></gy-step>
        <gy-step title="注册成功"></gy-step>
      </gy-steps>
    </div>
    <div class="gy-register-content mt-3" v-if="current === 0">
      <div
        style="
          padding: 0 40px;
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: center;
        "
      >
        <el-input
          class="gy-register-input"
          v-model="code"
          maxlength="6"
          placeholder="请填写邀请码"
          @input="accountInput"
        ></el-input>
        <button
          class="gy-register-next"
          style="margin-bottom: 30px"
          @click="nextStep"
        >
          下一步
        </button>
      </div>
    </div>
    <div
      class="gy-register-content"
      v-if="current === 1"
      style="
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
      "
    >
      <el-form
        style="margin: 40px 0"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
        @submit.native.prevent
      >
        <el-form-item label="邀请信息：">
          <p style="text-align: left">
            <span>{{ codeData.merchant_name }}</span>
            <span
              v-if="codeData.type === 'merchant' && codeData.org_type === 3"
            >
              ---{{ codeData.org_name }}
            </span>
          </p>
        </el-form-item>
        <el-form-item label="手机号码：" prop="user.mobile">
          <el-input
            v-model="ruleForm.user.mobile"
            maxlength="11"
            @input="queryMobileSearchPatient"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户姓名：" prop="user.name">
          <el-input
            v-model="ruleForm.user.name"
            :disabled="isSelect"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="
            codeData.org_type === 3
              ? meta.autoType === 'adjust'
                ? '诊所名称：'
                : '门诊名称：'
              : '商户名称：'
          "
          prop="merchant.name"
          v-if="codeData.type === 'merchant'"
        >
          <el-input v-model="ruleForm.merchant.name" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item
          label="调剂中心："
          prop="merchant.adjust"
          v-if="codeData.type === 'merchant' && meta.autoType === 'adjust'"
        >
          <el-input
            v-model="ruleForm.merchant.adjust"
            maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="调剂类型："
          prop="merchant.adjust_type"
          v-if="codeData.type === 'merchant' && meta.autoType === 'adjust'"
        >
          <el-checkbox-group
            v-model="ruleForm.merchant.adjust_type"
            maxlength="20"
          >
            <el-checkbox :label="1" style="margin-right: 20px"
              >饮片</el-checkbox
            >
            <el-checkbox :label="2" style="margin-right: 20px"
              >颗粒</el-checkbox
            >
            <el-checkbox :label="3" style="margin-right: 20px"
              >小包</el-checkbox
            >
            <el-checkbox :label="4" style="margin-right: 20px"
              >成药</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <el-form-item v-if="!isSelect" label="账号密码：" prop="user.pass_word">
          <el-input v-model="ruleForm.user.pass_word" show-password></el-input>
        </el-form-item>
        <el-form-item label-width="0" prop="protocol" class="text-center">
          <el-checkbox v-model="ruleForm.protocol"></el-checkbox>
          <a
            href="javascript: void(0);"
            class="ml-2 text-primary"
            @click="openDrawer('protocol')"
          >
            平台注册协议
          </a>
          <a
            href="javascript: void(0);"
            class="ml-2 text-primary"
            @click="openDrawer('agreement')"
          >
            最终用户使用协议
          </a>
        </el-form-item>
        <div style="padding: 0 20px">
          <button class="gy-register-next" @click="complete('ruleForm')">
            下一步
          </button>
        </div>
      </el-form>
    </div>
    <div
      class="gy-register-content mt-3"
      v-if="current === 2"
      style="
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
      "
    >
      <img src="@/assets/register.png" style="width: 200px; margin-top: 50px" />
    </div>
    <el-drawer :visible.sync="drawer" direction="btt" size="100%">
      <iframe class="w-full h-full" :src="protocolSrc" frameborder="0"></iframe>
    </el-drawer>
  </div>
</template>

<script>
import { inviteCodeService } from "@/api";
export default {
  data() {
    return {
      adjust_type:["",'饮片','颗粒','小包','成药'],
      current: 0,
      code: "",
      codeData: {
        merchant_name: "",
        org_type: 0,
        org_name: "",
      },
      meta: {
        autoType: "",
      },
      ruleForm: {
        user: {
          name: "",
          mobile: "",
          pass_word: "",
        },
        merchant: {
          cname: "",
          name: "",
          adjust: "",
          adjust_type: [],
        },
        protocol: undefined,
      },
      protocol: [],
      protocolObj: {
        protocol: "/public/protocol",
        agreement: "/public/agreement",
      },
      protocolSrc: "",
      drawer: false,
      isSelect: true,
    };
  },
  created() {
    if (this.$route.query.code) {
      this.code = this.$route.query.code;
      this.meta = Object.assign(this.meta, JSON.parse(this.$route.query.meta));
    }
  },
  computed: {
    rules() {
      let validateMobile = (rule, value, callback) => {
        let myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        if (!myreg.test(value)) {
          callback(new Error("请填写正确的手机号码"));
        } else {
          callback();
        }
      };
      let merchantNameMessage =
        this.codeData.org_type === 3
          ? this.meta.autoType === "adjust"
            ? "诊所名称"
            : "门诊名称"
          : "商户名称";
      return {
        "user.mobile": [
          { required: true, message: "请填写用户手机号码", trigger: "blur" },
          { max: 11, message: "手机号码格式不正确", trigger: "blur" },
          {
            validator: validateMobile,
            message: "手机号码格式不正确",
            trigger: "blur",
          },
        ],
        "user.name":[
          { required: true, message: "请填写用户名", trigger: "blur" }
        ],
        "user.pass_word": [
          { required: true, message: "请填写用户密码", trigger: "blur" },
        ],
        "merchant.cname": [
          { required: true, message: "请填写企业名称", trigger: "blur" },
        ],
        "merchant.name": [
          {
            required: true,
            message: `请填写${merchantNameMessage}`,
            trigger: "blur",
          },
        ],
        "merchant.adjust": [
          {
            required: true,
            message: "请填写调剂中心名称",
            trigger: "blur",
          },
        ],
        "merchant.adjust_type": [
          {
            required: true,
            message: "请选择调剂中心类型",
            trigger: "blur",
          },
        ],
        protocol: [
          { required: true, message: "请阅读后勾选协议", trigger: "change" },
        ],
      };
    },
  },
  watch: {
    "ruleForm.user.name": {
      async handler(val) {
        if (!val) {
          this.ruleForm.merchant.name = "";
          this.ruleForm.merchant.adjust = undefined;
          this.ruleForm.merchant.adjust_type = [];
          return;
        }
        if (this.codeData.org_type === 3) {
          this.ruleForm.merchant.name =
            val + (this.meta.autoType ? "诊所" : "门诊");
          if (this.meta.autoType === "adjust") {
            this.ruleForm.merchant.adjust =
              val + (this.meta.autoType ? "调剂中心" : "");
          } else {
            this.ruleForm.merchant.adjust = undefined;
            this.ruleForm.merchant.adjust_type = [];
          }
        }
      },
    },
  },
  methods: {
    accountInput(val) {
      //账号的实时输入
      let codeReg = new RegExp("[A-Za-z0-9]+"), //正则 英文+数字；
        len = val.length,
        str = "";
      for (var i = 0; i < len; i++) {
        if (codeReg.test(val[i])) {
          str += val[i];
        }
      }
      this.code = str;
    },
    nextStep() {
      if (this.code.length < 6) {
        this.$message.error("邀请码输入有误！");
        return;
      }
      inviteCodeService
        .selectInvitationCodeInfo({
          code: this.code,
        })
        .then((res) => {
          if (res.code === 0) {
            this.codeData = res.data;
            this.current++;
          } else {
            this.$message.error("邀请码输入有误！");
          }
        });
      // this.current++;
    },
    async complete(formName) {
      if (!this.ruleForm.protocol) {
        this.$message.error("请阅读并勾选协议！");
        return;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.merchant.cname = this.ruleForm.merchant.name;
          inviteCodeService
            .useInvitationCode({
              code: this.code,
              ...this.ruleForm,
            })
            .then((res) => {
              if (res.code === 0) {
                this.$message.success("申请成功！");
                this.current++;
                let that = this;
                setTimeout(function () {
                  that.$router.push({
                    path: "/login",
                  });
                }, 2000);
              } else {
                this.$message({
                  message: res.msg,
                  type: "error",
                  offset: 300,
                });
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    openDrawer(name) {
      this.protocolSrc = this.protocolObj[name];
      this.drawer = true;
    },
    queryMobileSearchPatient(keyword) {
      if (keyword.length === 11) {
        inviteCodeService
          .queryUserInfo({ mobile: keyword })
          .then((res) => {
            if (res.code === 0) {
              if (res.data.name !== "") {
                this.ruleForm.user.name = res.data.name;
              } else {
                this.initUser(false);
              }
            }
          })
          .catch(() => {
            this.initUser();
          });
      } else {
        this.initUser();
      }
    },
    initUser(flat = true) {
      this.isSelect = flat;
      this.ruleForm.user.name = "";
    },
    handleSelect(user) {
      let [name, mobile] = user.value.split(",");
      this.isSelect = true;
      this.ruleForm.user.name = name;
      this.ruleForm.user.mobile = mobile;
    },
  },
};
</script>

<style lang="less">
.gy-register {
  max-width: 600px;
  padding: 30px 0;
  margin: 0 auto;
  &-title {
    font-weight: normal;
    font-size: 20px;
    color: #35a8a4;
    padding: 50px 0;
  }
  &-steps {
    width: 80%;
    margin: 0 auto;
  }
  &-content {
    text-align: center;
  }
  &-input {
    max-width: 400px;
    margin: 100px auto;
    & > input {
      box-sizing: border-box;
      width: 100%;
      line-height: 1.8;
      font-size: 20px;
      padding: 0 20px;
      border-radius: 15px;
      border: 1px solid #aaa;
      outline: none;
    }
  }
  &-next {
    width: 100%;
    font-size: 20px;
    padding: 5px 0;
    color: white;
    background-color: #35a8a4;
    border: none;
    outline: none;
    cursor: pointer;
  }
}
</style>
